import { Component, inject } from "@angular/core";
import { ManualPageType } from "@app/manual/models/manual-page-type";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";

@Component({
    selector: "api-powerbi-usage",
    templateUrl: "./api-powerbi-usage.component.html",
    styleUrls: ["./api-powerbi-usage.component.scss"]
})
export class ApiPowerBIUsageComponent {
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    apiUrl: string;

    constructor() {
        this.apiUrl = window.location.origin + "/api";
    }

    openProfile() {
        this._tabService.generateTab(this._pages.Profile, null, null, null, "api-keys");
    }

    openReleaseNotes() {
        window.open(this._pages.ReleaseNotesExternal, "_blank");
    }

    openApiUsageManual() {
        this._tabService.openInternalManual(ManualPageType.ApiUsage);
    }

    openGetRiskDataManual() {
        this._tabService.openInternalManual(ManualPageType.RiskDataApi);
    }
}
